module.exports = __webpack_public_path__ + "frontend/images/homepage/carousel/mobile/2@2.png?bbd4a376c0bc1fb86511d6514a4b7d95";